import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TTableHeaderCell, IDeps } from './models';
import { TableHeaderCell as Component } from './table-header-cell';
import styles from './styles/styles.css';

export const TableHeaderCell = createWidget<IDeps, TTableHeaderCell>({ styles })(Component);
